var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22740",
    "data-name": "Group 22740",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 109.944,
    height: 128.494,
    viewBox: "0 0 109.944 128.494",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e2e2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.136,
    y1: 0.31,
    x2: 0.841,
    y2: 0.895,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.389,
    y1: 0.273,
    x2: 0.73,
    y2: 0.969,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#57111f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#8a1c32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.65,
    y1: 0.194,
    x2: 0.345,
    y2: 0.815,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#691525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#9b1f37"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.158,
    y1: 0.23,
    x2: 0.863,
    y2: 0.787,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.158,
    y1: 0.23,
    x2: 0.864,
    y2: 0.787,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13900",
    "data-name": "Path 13900",
    d: "M4486.784,164l5.373,10.776,11.912,1.781L4495.481,185l1.985,11.88-10.683-5.565L4476.1,196.88l1.991-11.88-8.592-8.443,11.911-1.781Z",
    transform: "translate(-4431.812 -164)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13901",
    "data-name": "Path 13901",
    d: "M4056.908,478.9l3.822,7.674,8.48,1.266-6.117,6.011,1.421,8.456-7.606-3.958-7.606,3.958,1.415-8.456-6.117-6.011,8.48-1.266Z",
    transform: "translate(-4033.272 -459.364)",
    fill: "url(#linear-gradient-2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13902",
    "data-name": "Path 13902",
    d: "M3871.535,886.9l2.965,5.949,6.576.98-4.74,4.659,1.092,6.551-5.894-3.071-5.894,3.071,1.1-6.551L3862,893.83l6.57-.98Z",
    transform: "translate(-3862 -842.053)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13903",
    "data-name": "Path 13903",
    d: "M5067.2,478.9l-3.821,7.674-8.48,1.266,6.117,6.011-1.415,8.456,7.6-3.958,7.606,3.958-1.414-8.456,6.117-6.011-8.48-1.266Z",
    transform: "translate(-4980.895 -459.364)",
    fill: "url(#linear-gradient-4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13904",
    "data-name": "Path 13904",
    d: "M5336.335,886.9l-2.965,5.949-6.57.98,4.74,4.659-1.1,6.551,5.894-3.071,5.894,3.071-1.1-6.551,4.74-4.659-6.57-.98Z",
    transform: "translate(-5235.926 -842.053)",
    fill: "url(#linear-gradient-5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13905",
    "data-name": "Path 13905",
    d: "M4682.085,1612.8l12.122,29.865-13.643-2.854.05-.019-7.786,11.558-12.128-29.871Z",
    transform: "translate(-4611.15 -1522.919)",
    fill: "url(#linear-gradient-6)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13906",
    "data-name": "Path 13906",
    d: "M4329.2,1620.777l-12.544,29.7-7.631-11.663.05.019-13.679,2.661,12.544-29.691Z",
    transform: "translate(-4268.512 -1521.981)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13907",
    "data-name": "Path 13907",
    d: "M4286.077,786.044c0,1.694-2.066,3.2-2.32,4.82-.261,1.663,1.234,3.735.726,5.3-.515,1.594-2.947,2.388-3.7,3.865s.019,3.921-.956,5.261-3.536,1.352-4.715,2.531-1.185,3.735-2.531,4.715-3.778.2-5.261.955-2.271,3.182-3.865,3.7c-1.569.509-3.635-.986-5.3-.726-1.62.254-3.127,2.32-4.821,2.32s-3.2-2.066-4.82-2.32c-1.663-.261-3.734,1.235-5.3.726-1.594-.515-2.388-2.947-3.865-3.7s-3.921.019-5.261-.955-1.352-3.536-2.531-4.715-3.735-1.185-4.715-2.531-.2-3.778-.956-5.261-3.183-2.271-3.7-3.865c-.509-1.57.986-3.635.726-5.3-.254-1.619-2.32-3.127-2.32-4.82s2.066-3.2,2.32-4.82c.26-1.663-1.235-3.735-.726-5.3.515-1.594,2.947-2.388,3.7-3.865s-.019-3.921.955-5.261,3.536-1.352,4.715-2.531,1.185-3.735,2.531-4.715,3.779-.2,5.261-.955,2.271-3.183,3.865-3.7c1.569-.509,3.635.986,5.3.726,1.619-.254,3.126-2.32,4.82-2.32s3.2,2.066,4.82,2.32c1.663.26,3.735-1.235,5.3-.726,1.595.515,2.389,2.947,3.865,3.7s3.92-.019,5.261.955,1.353,3.536,2.531,4.715,3.735,1.185,4.715,2.531.2,3.778.955,5.261,3.183,2.271,3.7,3.865c.509,1.57-.986,3.635-.726,5.3C4284.011,782.843,4286.077,784.356,4286.077,786.044Z",
    transform: "translate(-4198.354 -716.741)",
    fill: "url(#linear-gradient-8)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 24.462,
    cy: 24.462,
    rx: 24.462,
    ry: 24.462,
    transform: "translate(30.51 44.841)",
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 22.154,
    cy: 22.154,
    rx: 22.154,
    ry: 22.154,
    transform: "translate(32.818 47.149)",
    fill: "url(#linear-gradient-9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/Silver.abbc69fa075dfb6fce70f9e0c458413b.svg";
export { ForwardRef as ReactComponent };